import ModalRedux from './ModalRedux'
import reducer, { showModal, hideModal } from './reducers'
import { modalVisible } from './selectors'

export default ModalRedux

export { reducer as ModalReducer, showModal, hideModal, modalVisible }
